<div class="n-table-wrapper">
    <h2>{{refDataCollections[collection] || collection}}</h2>
    @if (loading()) {
    <div class="n-spinner-overlay">
        <mat-spinner></mat-spinner>
    </div>
    } @else {

    @if (nullCategoryExists()) {
    <mat-form-field class="example-chip-list">
        <mat-label>Uncategorized</mat-label>
        <mat-chip-grid #chipGrid aria-label="Enter item">
            @for (item of getCategoryItems(null); track item.id) {
            <mat-chip-row [editable]="true" (edited)="editItem(item, null, $event)" (removed)="removeItem(item, null)"
                [aria-description]="'press enter to edit ' + item.name">
                <button matChipEdit [attr.aria-label]="'edit ' + item.name" class="chip-icon-button">
                    <mat-icon>edit</mat-icon>
                </button>
                {{item.name}}
                <button matChipRemove [attr.aria-label]="'remove ' + item.name">
                    <mat-icon>cancel</mat-icon>
                </button>
            </mat-chip-row>
            }
        </mat-chip-grid>
        <input placeholder="New item..." [matChipInputFor]="chipGrid"
            [matChipInputSeparatorKeyCodes]="separatorKeysCodes" [matChipInputAddOnBlur]="addOnBlur"
            (matChipInputTokenEnd)="addItem($event, null)" />
    </mat-form-field>
    }

    @for (category of categories(); track category) {
    <mat-form-field class="example-chip-list">
        <mat-label>{{ category.name }}</mat-label>
        <mat-chip-grid #chipGrid aria-label="Enter item">
            @for (item of getCategoryItems(category.id); track item.id) {
            <!-- (removed)="remove(fruit)"  -->
            <mat-chip-row [editable]="true" (edited)="editItem(item, category.id, $event)"
                (removed)="removeItem(item, category.id)" [aria-description]="'press enter to edit ' + item.name">
                <button matChipEdit [attr.aria-label]="'edit ' + item.name" class="chip-icon-button">
                    <mat-icon>edit</mat-icon>
                </button>
                {{item.name}}
                <button matChipRemove [attr.aria-label]="'remove ' + item.name">
                    <mat-icon>cancel</mat-icon>
                </button>
            </mat-chip-row>
            }
        </mat-chip-grid>
        <input placeholder="New item..." [matChipInputFor]="chipGrid"
            [matChipInputSeparatorKeyCodes]="separatorKeysCodes" [matChipInputAddOnBlur]="addOnBlur"
            (matChipInputTokenEnd)="addItem($event, category.id)" />
    </mat-form-field>
    }

    <div class="n-lcr-row">
        <div class="n-lcr-left">&nbsp;</div>
        <div class=" n-lcr-center" style="display:flex; gap: 5px; align-items: center; justify-content: center;">
            <button matFab extended color="primary" class="n-save-button"
                (click)="addCategory()"><mat-icon>add</mat-icon>Add Category</button>
        </div>
        <div class="n-lcr-right"></div>
    </div>
    }
</div>